import { useState } from 'react'
import { useTheme } from '../../contexts/ThemeContext'
import { useProfileContext } from '../../contexts/ProfileContext'
import { CATEGORIAS_GASTO, CATEGORIAS_INGRESO } from '../../lib/categorias'
const EMOCIONES = ['Necesario', 'Me alegró', 'Impulsivo', 'Obligación']

export default function EditTransaccionModal({ gasto, onSave, onDelete, onClose }) {
  const { theme } = useTheme()
  const { profile } = useProfileContext()
  const s = makeStyles(theme)
  const pronombre = profile?.genero === 'femenino' ? 'a' : profile?.genero === 'masculino' ? 'o' : ''

  const cats = gasto.tipo === 'ingreso' ? CATEGORIAS_INGRESO : CATEGORIAS_GASTO
  const catActual = cats.find(c => c.label === gasto.categoria) || cats[0]

  const [monto,       setMonto]       = useState(String(gasto.monto))
  const [descripcion, setDescripcion] = useState(gasto.descripcion || '')
  const [categoria,   setCategoria]   = useState(catActual)
  const [emocion,     setEmocion]     = useState(gasto.emocion || null)
  const [fecha,       setFecha]       = useState(() => {
    const d = new Date(gasto.fecha)
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
  })
  const [confirmDel,  setConfirmDel]  = useState(false)
  const [guardando,   setGuardando]   = useState(false)

  const montoColor = gasto.tipo === 'ingreso' ? theme.sage
    : gasto.tipo === 'ahorro' ? theme.gold : theme.terra

  async function handleSave() {
    const n = parseFloat(monto)
    if (!n || n <= 0) return
    setGuardando(true)
    await onSave(gasto.id, {
      monto: n,
      descripcion: descripcion || categoria.label,
      categoria: gasto.tipo === 'ahorro' ? gasto.categoria : categoria.label,
      emoji: gasto.tipo === 'ahorro' ? gasto.emoji : categoria.emoji,
      fecha: new Date(fecha + 'T12:00:00').toISOString(),
      ...(gasto.tipo === 'gasto' && { emocion }),
    })
    setGuardando(false)
    onClose()
  }

  async function handleDelete() {
    if (!confirmDel) { setConfirmDel(true); return }
    await onDelete(gasto.id)
    onClose()
  }

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.sheet} onClick={e => e.stopPropagation()}>
        <div style={s.handle} />

        <div style={s.sheetHeader}>
          <div style={s.tipoBadge}>
            {{ gasto: 'gasto', ingreso: 'ingreso', ahorro: 'ahorro' }[gasto.tipo]}
          </div>
          <input
            type="date"
            style={{ ...s.fechaInput, color: theme.inkLight, borderColor: theme.cardBorder, background: theme.inputBg }}
            value={fecha}
            max={(() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}` })()}
            onChange={e => setFecha(e.target.value)}
          />
        </div>

        {/* Monto */}
        <div style={s.field}>
          <p style={s.fieldLabel}>monto</p>
          <input
            style={{ ...s.input, ...s.montoInput, color: montoColor }}
            type="number" value={monto}
            onChange={e => setMonto(e.target.value)}
          />
        </div>

        {/* Descripción */}
        <div style={s.field}>
          <p style={s.fieldLabel}>descripción</p>
          <input
            style={s.input} value={descripcion}
            placeholder="¿qué fue?"
            onChange={e => setDescripcion(e.target.value)}
          />
        </div>

        {/* Categoría — solo gasto/ingreso */}
        {gasto.tipo !== 'ahorro' && (
          <div style={s.field}>
            <p style={s.fieldLabel}>{gasto.tipo === 'ingreso' ? '¿de dónde?' : '¿en qué?'}</p>
            <div style={s.catGrid}>
              {cats.map(c => {
                const Ic = c.icon
                return (
                  <button key={c.label} onClick={() => setCategoria(c)}
                    style={{ ...s.catBtn, ...(categoria.label === c.label ? { borderColor: theme.accent, background: theme.accent + '18', color: theme.accent } : { color: theme.inkLight }) }}>
                    {Ic && <Ic size={16} />}
                    <span style={{ fontSize: 11, color: categoria.label === c.label ? theme.accent : theme.inkMid }}>{c.label}</span>
                  </button>
                )
              })}
            </div>
          </div>
        )}

        {/* Emoción — solo gastos */}
        {gasto.tipo === 'gasto' && (
          <div style={s.field}>
            <p style={s.fieldLabel}>¿cómo lo sentiste?</p>
            <div style={s.emoGrid}>
              {EMOCIONES.map(e => (
                <button key={e} onClick={() => setEmocion(emocion === e ? null : e)}
                  style={{ ...s.emoBtn, ...(emocion === e ? { borderColor: theme.gold, background: theme.gold + '18' } : {}) }}>
                  <span style={{ fontSize: 12, color: emocion === e ? theme.ink : theme.inkMid }}>{e}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        <div style={s.actions}>
          <button style={s.saveBtn} onClick={handleSave} disabled={guardando}>
            {guardando ? 'guardando...' : 'guardar cambios ✦'}
          </button>
          <button
            style={{ ...s.deleteBtn, ...(confirmDel ? s.deleteBtnConfirm : {}) }}
            onClick={handleDelete}
          >
            {confirmDel ? `¿segur${pronombre}? toca de nuevo para eliminar` : 'eliminar registro'}
          </button>
          {confirmDel && (
            <button style={s.cancelBtn} onClick={() => setConfirmDel(false)}>cancelar</button>
          )}
        </div>
      </div>
    </div>
  )
}

const makeStyles = (t) => ({
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
    zIndex: 300, display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
  },
  sheet: {
    background: t.paper, borderRadius: '28px 28px 0 0',
    padding: '16px 22px 40px', width: '100%', maxWidth: 420,
    maxHeight: '88vh', overflowY: 'auto',
  },
  handle: { width: 40, height: 4, borderRadius: 2, background: t.blush, margin: '0 auto 16px' },
  sheetHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 },
  tipoBadge: {
    fontFamily: "'DM Sans', sans-serif", fontSize: 12, fontWeight: 600,
    color: t.inkMid, background: t.cream, padding: '5px 12px', borderRadius: 20,
    border: `1px solid ${t.cardBorder}`,
  },
  fechaInput: {
    border: `1.5px solid`, borderRadius: 12, padding: '6px 10px',
    fontFamily: "'DM Sans', sans-serif", fontSize: 13, outline: 'none',
  },
  field: { marginBottom: 16 },
  fieldLabel: {
    fontSize: 11, letterSpacing: 1.2, textTransform: 'uppercase',
    color: t.inkLight, fontWeight: 500, margin: '0 0 8px',
    fontFamily: "'DM Sans', sans-serif",
  },
  input: {
    width: '100%', padding: '11px 14px', borderRadius: 14,
    border: `1.5px solid ${t.cardBorder}`, background: t.inputBg,
    fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: t.ink,
    outline: 'none', boxSizing: 'border-box',
  },
  montoInput: {
    fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 600,
    textAlign: 'center',
  },
  catGrid: { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 8 },
  catBtn: {
    padding: '10px 6px', borderRadius: 14,
    border: `1.5px solid ${t.cardBorder}`, background: t.paper,
    cursor: 'pointer', fontSize: 16, display: 'flex',
    flexDirection: 'column', alignItems: 'center', gap: 3,
  },
  emoGrid: { display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 8 },
  emoBtn: {
    padding: '10px 6px', borderRadius: 14,
    border: `1.5px solid ${t.cardBorder}`, background: t.paper,
    cursor: 'pointer', fontSize: 16, display: 'flex',
    flexDirection: 'column', alignItems: 'center', gap: 3,
  },
  actions: { marginTop: 20, display: 'flex', flexDirection: 'column', gap: 10 },
  saveBtn: {
    width: '100%', padding: '15px', borderRadius: 20, border: 'none',
    background: t.cardGradient, color: 'white',
    fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontStyle: 'italic',
    cursor: 'pointer',
  },
  deleteBtn: {
    width: '100%', padding: '13px', borderRadius: 16,
    border: `1.5px solid ${t.blush}`, background: 'transparent',
    fontFamily: "'DM Sans', sans-serif", fontSize: 14,
    color: t.inkLight, cursor: 'pointer',
  },
  deleteBtnConfirm: {
    borderColor: t.mauve, color: t.mauve,
    fontFamily: "'DM Sans', sans-serif", fontSize: 14,
  },
  cancelBtn: {
    width: '100%', padding: '10px', border: 'none', background: 'transparent',
    fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: t.inkLight,
    cursor: 'pointer', textDecoration: 'underline',
  },
})
